import { cn } from "@/lib/utils";

type SpinnerSize = number | "sm" | "md" | "lg";

interface SpinnerProps {
  size?: SpinnerSize;
  color?: string;
  className?: string;
}

const SIZE_MAP: Record<Exclude<SpinnerSize, number>, number> = {
  sm: 14,
  md: 24,
  lg: 32,
};

export function SpinnerIcon({
  color,
  size = "md",
  className,
}: SpinnerProps = {}) {
  const numericSize =
    typeof size === "number" ? size : SIZE_MAP[size] ?? SIZE_MAP.md;

  const bars = Array(12).fill(0);

  const getBarStyle = (index: number) => ({
    animation: "spinner-fade 1.2s linear infinite",
    animationDelay: `${-1.2 + index * 0.1}s`,
    transform: `rotate(${index * 30}deg) translate(146%)`,
    background: color ?? "currentColor",
    borderRadius: "6px",
    height: "8%",
    position: "absolute" as const,
    width: "24%",
  });

  return (
    <div
      className={cn(
        "flex size-full cursor-pointer items-center justify-center",
        className,
      )}
    >
      <div
        className={cn(
          "relative flex items-center justify-center",
          `h-[${numericSize}px] w-[${numericSize}px]`,
        )}
        style={{ height: numericSize, width: numericSize }}
      >
        {bars.map((_, index) => (
          <div
            key={`spinner-bar-${index}`}
            className="absolute"
            style={getBarStyle(index)}
          />
        ))}
        <style>{`
          @keyframes spinner-fade {
            0% { opacity: 1; }
            100% { opacity: 0.15; }
          }
        `}</style>
      </div>
    </div>
  );
}
